var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"fill-height":"","column":""}},[_vm._l((_vm.items),function(item,itemIndex){return _c('div',{key:itemIndex},[(item.type == 'banner' && itemIndex == 0)?[_c('v-container',{class:_vm.outerContainer},[_c('v-flex',{staticClass:"mt-15"},[_c('v-img',{attrs:{"width":_vm.$vuetify.breakpoint.smAndUp ? '500px' : '250px',"contain":"","src":{ backgroundImage: ("url(" + (item.image) + ")") }}}),_c('div',{staticClass:"space-mono text-left pt-10",class:_vm.$vuetify.breakpoint.smAndUp ? 'h3' : 'h4'},[_c('span',{staticClass:"meeting-highlighted-string",attrs:{"contenteditable":_vm.editableContent},domProps:{"innerHTML":_vm._s(item.heading)},on:{"focusout":function($event){return _vm.editableData('banner', { element: 'heading' })}}})]),_c('div',{staticClass:"h5 poppins text-left",attrs:{"contenteditable":_vm.editableContent},domProps:{"innerHTML":_vm._s(item.subtitle)},on:{"focusout":function($event){return _vm.editableData('banner', { element: 'subtitle' })}}})],1),(_vm.pageType == 'Canvas')?_c('RowControls',{attrs:{"rowIndex":itemIndex}}):_vm._e()],1)]:_vm._e(),(item.type == 'grids')?[_c('Grid2',{attrs:{"item":item,"index":itemIndex,"styles":{
							text: 'body poppins',
							image: {
								contain: true,
								wrapper: '',
								class: '',
								height: 'auto',
								width: 'auto',
								maxWidth: '100%',
								maxHeight: '',
								custom: {
									margin: '0 auto'
								}
							},
							heading1: {
								wrapper: 'justify-center',
								classMobile: 'h5 space-mono meeting-highlighted-string mt-10',
								classLarge: 'h4 space-mono meeting-highlighted-string mt-10',
								after: '',
								guideWrapper: '',
								guideClass: 'mt-10 ml-5'
							},
							heading2: {
								wrapper: 'justify-center',
								classMobile: 'h5 space-mono meeting-highlighted-string mt-10',
								classLarge: 'h4 space-mono meeting-highlighted-string mt-10',
								after: '',
								guideWrapper: '',
								guideClass: 'mt-10 ml-5'
							},
							textcard: {
								outlined: false,
								elevation: 0,
								card: 'bpmeeting-card text-center py-5 px-5',
								text: 'h5 space-mono meeting-highlighted-string-white mb-5',
								subtitle: 'body poppins text-left mt-5'
							},
							imagecard: {
								doubleCard: false,
								elevation: 0,
								outlined: false,
								card: 'pa-5',
								imagePosition: 'top',
								image: {
									height: '',
									width: '250px'
								},
								text: 'h5 poppins font-weight-bold text-left my-3',
								subtitle: 'text-left body poppins grey-text'
							},
							dialog: {
								elevation: '',
								cardClass: 'py-5 px-5 my-5',
								cardColor: '#41FEAF',
								innerCard: 'business-process-inner-card  text-center px-5 py-5',
								dialogTitle: 'h5 space-mono meeting-highlighted-string-white mb-5',
								textWrapper: 'body poppins text-left responsive-text',
								dialogName: 'body poppins font-weight-bold text-left mr-3 responsive-text',
								custom: {
									text: '',
									textClass: 'mt-5'
								}
							}
						}}})]:_vm._e()],2)}),_c('ImageUploader')],2)}
var staticRenderFns = []

export { render, staticRenderFns }